import { Box, Container, Stack, styled, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useContext, useEffect, useState } from 'react';

import { AuthContext } from 'contexts/AuthContext';
import { RoundButton } from 'components/common/Button/RoundButton';

const StyledMainBox = styled(Box)(() => ({
  backgroundColor: '#E7E5E0',
  display: 'flex',
  minHeight: '84px',
}));

export default function SlackCommunityJoin() {
  const [show, setShow] = useState(false);
  const authContext = useContext(AuthContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    setShow(false);
    if (authContext.user && authContext.user.showJoinSlack) {
      setShow(true);
      return;
    }
  }, [authContext.user]);

  if (!show) {
    return <></>;
  }

  return (
    <StyledMainBox>
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={1.5}
          alignItems={{ xs: 'stretch', md: 'center' }}
          justifyContent={{ xs: 'space-evenly', md: 'space-between' }}
          sx={{ py: 3, width: '100%' }}
          alignContent="stretch"
        >
          <Typography
            variant={isMobile ? 'subtitle2' : 'subtitle1'}
            color={theme.palette.common.black}
            fontWeight={600}
            component={'div'}
          >
            Your premium account includes access to our private Slack community with real-time gig alerts.{' '}
            <span
              style={{ textDecoration: 'underline', color: theme.palette.primary.dark, cursor: 'pointer' }}
              onClick={() => window.open('https://help.shoutt.co/en/articles/4032002', '_blank')}
            >
              Learn more.
            </span>{' '}
          </Typography>

          <RoundButton
            variant="contained"
            onClick={() => window.open(process.env.REACT_APP_SLACK_JOIN_URL ?? '', '_blank')}
            sx={{
              width: { xs: '100%', sm: '200px' },
              marginLeft: '30px',
            }}
          >
            Join now
          </RoundButton>
        </Stack>
      </Container>
    </StyledMainBox>
  );
}
